import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, PropType } from 'vue';

import { SdsSection2Label } from '@/interfaces/model/general/sds';
import SdsSection2LabelForm from '@/views/dashboard/sdsDrawer/forms/SdsSection2LabelForm.vue';
import SdsSection2LabelSignalWordsForm from '@/views/dashboard/sdsDrawer/forms/SdsSection2LabelSignalWordsForm.vue';
import { VForm } from 'vuetify/lib/components';
import { SignalWordId } from '@/lib/enum/SignalWordId';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection2Label',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  sdsSection2Label: {
    type: Object as PropType<SdsSection2Label>,
    required: true,
  },
},
  emits: ["update:isValid", "update:sdsSection2Label"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:sdsSection2Label', data: SdsSection2Label): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const form = ref<InstanceType<typeof VForm> | null>(null);


const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateBomb = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.bomb = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateFire = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.fire = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateFireCircle = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.fire_circle = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateGas = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.gas = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateToxic = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.toxic = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateCorrosion = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.corrosion = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateExclamation = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.exclamation = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateHealth = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.health = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateEnvironment = (e: boolean) => {
  const updatedData = { ...props.sdsSection2Label };
  updatedData.environment = e;

  if (props.isEditing) emits('update:sdsSection2Label', updatedData);
};

const updateSignalWordIdAndWords = (e: string) => {
  const updatedData = { ...props.sdsSection2Label };

  updatedData.signal_word_id = e;
  updatedData.signal_words = SignalWordId.toWord(e);

  emits('update:sdsSection2Label', updatedData);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,props, form, emits, updateIsValid, updateBomb, updateFire, updateFireCircle, updateGas, updateToxic, updateCorrosion, updateExclamation, updateHealth, updateEnvironment, updateSignalWordIdAndWords, SdsSection2LabelForm, SdsSection2LabelSignalWordsForm }
}

})